import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/system";
import { Stack, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
const StyledTypography = styled(Typography)({
  color: "white",
});

type Props = {
  children?: string;
};

interface ListItemProps {
  text: string;
}

const Footer = (props: Props) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const location = useLocation();

  const ListItemWithWhiteText: React.FC<ListItemProps> = ({ text }) => {
    let link = "";

    if (text.startsWith("081")) {
      // Se il testo inizia con +39, creiamo un link per fare una chiamata
      link = `tel:${text}`;
    } else if (text.startsWith("info")) {
      // Se il testo inizia con info, lo trattiamo come un'email
      // Aggiungi due destinatari separati da una virgola
      link = `mailto:partenopeimmobiliare@gmail.com`;
    } else if (text.toLowerCase().startsWith("via")) {
      // Se il testo inizia con "via", lo trattiamo come un indirizzo
      // Creiamo un link per Google Maps con l'indirizzo
      const address = text.slice(3).trim(); // Rimuoviamo "via" e gli spazi in eccesso
      link = `https://www.google.com/maps?q=${encodeURIComponent(address)}`;
    }
    return (
      <li>
        <StyledTypography
          sx={{
            width: isMobile ? "100%" : "70%",
            padding: isMobile ? "5px" : "5px 35px 5px 15px",
            fontSize: "14px",
            height: "100%",
            color: "#fff", // Colore del testo bianco
            textAlign: isMobile ? "center" : undefined,
            fontFamily: "ivymode",
            letterSpacing: "2px",
            borderLeft: isMobile ? "none" : "solid 0.5px white ",
          }}
          variant="body1"
        >
          {link ? (
            <a
              target="_blank"
              href={link}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </StyledTypography>
      </li>
    );
  };

  return (
    <Stack
      sx={{
        zIndex: 2,
        alignItems: "center",
        p: 6,
        width: isMobile ? "100%" : "100%",
        pb: isMobile ? 12 : undefined,
        display: location.pathname === "/immobili" ? "none" : "flex",
        position: "relative",
        backgroundColor: "#33414C",
      }}
    >
      <div id="footer" />
      <Grid container spacing={4}>
        <Grid item xs={12} sm={12}>
          <Typography
            sx={{
              textAlign: isMobile ? "center" : undefined,
              color: "white",
            }}
            variant="h4"
            fontFamily={"ivymode"}
          >
            {t("footer.contacts")}
          </Typography>
          <ul
            style={{
              width: "100%",
              listStyleType: "none",
              paddingLeft: 0,
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyItems: "space-between",
            }}
          >
            <Box>
              {" "}
              <ListItemWithWhiteText text="partenopeimmobiliare@gmail.com" />
              <ListItemWithWhiteText text="081 196 40 374" />
            </Box>
            <ListItemWithWhiteText text="Via Giuseppe Orsi, 28, 80128 Napoli NA" />
            <ListItemWithWhiteText text="Lun - Ven 9:30-13:30/16.00-19:00 | Sab 09:30-13:30" />
          </ul>
        </Grid>
      </Grid>
      <Link
        style={{
          position: "absolute",
          bottom: 30,
          fontFamily: "ivymode",
          right: 50,
          color: "#e6e6e6",
          borderBottom: "0.5 px solid",
        }}
        to="/privacy-policy"
      >
        {" "}
        Privacy Policy
      </Link>
    </Stack>
  );
};

export default Footer;
